import React from "react";

const UnauthorizedActionContext = React.createContext(()=>{})

export default UnauthorizedActionContext